import React, { Suspense, useState, useEffect, useRef } from "react";
import Drawer from 'react-modern-drawer';
import gridTemplateService from "./gridTemplateService";
import { CommonUtilities } from "commonUtils";
import Svg_icon from "components/flags/svg_icon";
import DeleteDialogueBox from "components/Common/deleteDialogue";

export default function AllSplitBox(param: any) {

    let [AllSplitRow, setAllSplitRow] = useState(0);
    let [allSplit, setAllSplit] = useState<any[]>([]);
    let [editParam, setEditParam] = useState<any>([]);
    let [pubWriterType, setpubWriterType] = useState(0);
    let [clientZone, setClientZone] = useState<any>([]);
    let [activeZone, setActiveZone] = useState<any>([]);
    let [saveOperation, setSaveOperation] = useState("");
    let [deleteStatus, setDeleteStatus] = useState(false);
    let [editComposer, setEditComposer] = useState(false);
    let [editPublisher, setEditPublisher] = useState(false);
    let [editCollector, setEditCollector] = useState(false);
    let [linkedTackPubT, setLinkedTackPubT] = useState<any[]>([]);
    let [pubWritersearchFor, setpubWritersearchFor] = useState("");

    var payload = {
        exportType: '', pageNumber: 1, pageSize: 10, searchFor: pubWritersearchFor,
        pubWriter: pubWriterType == 0 ? "Both" : pubWriterType == 1 ? "Writer" : "None",
        sameAS: param?.selectSplit?.trackPubTiD, trackSeq: param?.selectSplit?.trackSeq, type: "SplitInfo", zone: activeZone?.zoneID
    };

    const AllSplit = (zone: any) => {
        activeZone = zone
        setActiveZone(activeZone);
        payload.zone = activeZone?.zoneID;
        gridTemplateService.AllSplit(payload).then((res: any) => {
            allSplit = (CommonUtilities.relativeDataRemapping(res.data, res.headers.original))
            setAllSplit(allSplit)
            AllSplitRow = res.totalRows
            setAllSplitRow(AllSplitRow)
        })
    };

    useEffect(() => {
        setEditParam({ ...editParam, writerCodeDisplay: param?.selectSplit?.writerCodeDisplay })
        setEditParam({ ...editParam, publishersDisplay: param?.selectSplit?.publishersDisplay })
        setEditParam({ ...editParam, collectedByDisplay: param?.selectSplit?.collectedByDisplay })
        setEditParam({ ...editParam, writerCode: param?.selectSplit?.writerCode })
        setEditParam({ ...editParam, publishers: param?.selectSplit?.publishers })
        setEditParam({ ...editParam, collectedBy: param?.selectSplit?.collectedBy })

        console.log(param)
        if (param.allSplitStatus) {
            gridTemplateService.getAllClientZones({ isAllZone: false }).then((respond: any) => {
                clientZone = respond;
                setClientZone(clientZone)
                if (respond[0]) {
                    activeZone = respond[0];
                    setActiveZone(activeZone)
                    AllSplit(activeZone)
                }
            })
        }

    }, [param.allSplitStatus]);

    const closContactLODSplit = () => {
        param.closContactLODSplit()
    };

    var updateTrackSplitRole = {
        Collector: editCollector ? editParam?.collectedBy : "",
        Publisher: editPublisher ? editParam?.publishers : "",
        Writer: editComposer ? editParam?.writerCode : "",
        pubSplitList: [], pubWriter: "None", searchFor: "",
        trackPubFrom: param?.selectSplit?.trackPubTiD, updateAll: 0, zone: activeZone?.zoneID
    };

    const saveLodSplitWizard = (operation: any) => {
        var pubSplitList: any = []
        if (operation == "Save") {
            updateTrackSplitRole.updateAll = 0
            pubSplitList.push(param?.selectSplit?.trackPubTiD)
            updateTrackSplitRole.pubSplitList = pubSplitList
            gridTemplateService.updateTrackSplitRole(updateTrackSplitRole)
        }

        if (operation == "All") {
            updateTrackSplitRole.updateAll = 1
            updateTrackSplitRole.pubSplitList = []
            gridTemplateService.updateTrackSplitRole(updateTrackSplitRole)
        }

        if (operation == "Selected") {
            updateTrackSplitRole.updateAll = 0
            gridTemplateService.updateTrackSplitRole(updateTrackSplitRole)
        }
        console.log(updateTrackSplitRole)
        AllSplit(activeZone)
    };

    const Link_split = (e: any) => {
        const id = e.trackPubTID;

        setLinkedTackPubT((prev) => {
            const exists = prev.includes(id);

            if (exists) {
                // remove
                return prev.filter((item) => item !== id);
            } else {
                // add
                return [...prev, id];
            }
        });

        console.log(linkedTackPubT)
    };

    const checkboxLinked = (e: any) => {

        console.log(e)
        console.log(linkedTackPubT.filter((linked_list: any) => linked_list == e.trackPubTID))
        var found = linkedTackPubT.filter((linked_list: any) => linked_list == e.trackPubTID);
        console.log(found)
        return found.length == 0 ? false : true;
    };

    const save_wizard = (operation: any) => {
        saveOperation = operation
        setSaveOperation(saveOperation)
        deleteStatus = true;
        setDeleteStatus(deleteStatus)
    };

    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES 
        if (e == 1) {
            saveLodSplitWizard(saveOperation)
        }
        //e==2 NO
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    };

    return (
        <Drawer open={param.allSplitStatus} onClose={closContactLODSplit} direction='right' className='react-drawer allowHscroll allowVscroll' size={1200}>

            <div className="ws-9 pull-left box landing">

                <div className="box-header-main">
                    <h2 ><i className="icon-info hide"></i> Split Info</h2>
                </div>

                <div className="ws-12 pm pts">
                    <fieldset className="scheduler-border p0 m0">
                        <legend className="scheduler-border">  <h2>     <i className="fa fa-sticky-note-o"></i> Current track Info  </h2>  </legend>

                        <div className="ws-12">

                            <div className="ws-5">
                                <div className="form-format">
                                    <label className="control-label ws-4 text-right pr">  Track Name :  </label>
                                    <div className="label-entries ws-8  "> {param?.selectSplit?.trackPubTiD} </div>
                                </div>
                            </div>

                            <div className="ws-7">
                                <div className="form-format">
                                    <label className="control-label ws-2 text-right pr">  W|P|C  </label>
                                    <div className="label-entries ws-10  "> {param?.selectSplit?.writerCodeDisplay} |{param?.selectSplit?.publishersDisplay}  |  {param?.selectSplit?.collectedByDisplay}  </div>
                                </div>
                            </div>

                            <div className="ws-5">
                                <div className="form-format">
                                    <label className="control-label ws-4 text-right pr"> License Id :   </label>
                                    <div className="label-entries ws-8  "> {param?.selectSplit?.Licenseid} </div>
                                </div>
                            </div>

                        </div>

                    </fieldset>
                </div>

                <div className="box-content">

                    <div className="ws-12 pm box mbl">
                        <span className="mll pll ws-4 pull-right text-bold">Update</span>

                        <div className="ws-12 pm">
                            <label className="control-label ws-3 mt"> Composer/Writer</label>
                            <div className="label-entries ws-9">
                                <input className="form-control mgr ws-6 " value={editParam.writerCodeDisplay ?? ""} onChange={(e: any) => setEditParam({ ...editParam, writerCodeDisplay: e.target.value })} />
                                <button type="button" className="icon-btn edit pull-left" title="Select Contact" disabled={!editComposer}>
                                    <i className="icon-user-add"></i>
                                </button>

                                <input type="checkbox" checked={editComposer} onClick={() => setEditComposer(!editComposer)} title="Edit Composer/Writer" className="mt ws-1 " />
                            </div>
                        </div>

                        <div className="ws-12 pm">
                            <label className="control-label ws-3 mt"> Publisher</label>
                            <div className="label-entries ws-9">
                                <input className="form-control mgr ws-6 " value={editParam.publishersDisplay ?? ""} onChange={(e: any) => setEditParam({ ...editParam, publishersDisplay: e.target.value })} />
                                <button type="button" className="icon-btn edit pull-left" title="Select Contact" disabled={!editPublisher}>
                                    <i className="icon-user-add"></i>
                                </button>

                                <input type="checkbox" checked={editPublisher} onClick={() => setEditPublisher(!editPublisher)} title="Edit Publisher" className="mt ws-1 " />
                            </div>
                        </div>

                        <div className="ws-12 pm">
                            <label className="control-label ws-3 mt"> Collector</label>
                            <div className="label-entries ws-9">
                                <input className="form-control mgr ws-6 " value={editParam.collectedByDisplay ?? ""} onChange={(e: any) => setEditParam({ ...editParam, collectedByDisplay: e.target.value })} />
                                <button type="button" className="icon-btn edit pull-left" title="Select Contact" disabled={!editCollector}>
                                    <i className="icon-user-add"></i>
                                </button>

                                <input type="checkbox" checked={editCollector} onClick={() => setEditCollector(!editCollector)} title="Edit Collector" className="mt ws-1 " />
                            </div>
                        </div>
                    </div>

                    <div className="ws-12 pm box mbl">
                        <div className="ws-6 m0 mb">
                            <ul className="nav nav-tabs">
                                {
                                    clientZone?.map((valueList: any) => {
                                        return (
                                            <li className={activeZone?.zoneID == valueList?.zoneID ? "p0 pts pls prs active" : "p0 pts pls prs"} onClick={() => { AllSplit(valueList); }} >
                                                <span className="pull-left ms ">{valueList?.zoneID}</span>
                                                <Svg_icon IName={valueList?.zoneID} />
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>

                        <label className="ws-4 mt pl pull-right">

                            <div className="ws-3 pull-right" >
                                <input type="radio" name="pubWriterType" value="2" checked={pubWriterType == 2} onClick={() => setpubWriterType(2)} title="Cater for Search only" />By Search
                            </div>

                            <div className="ws-3 pull-right">
                                <input type="radio" name="pubWriterType" value="1" checked={pubWriterType == 1} onClick={() => setpubWriterType(1)} title="Similar Writer" />Writer
                            </div>

                            <div className="ws-3 pull-right" >
                                <input type="radio" name="pubWriterType" value="0" checked={pubWriterType == 0} onClick={() => setpubWriterType(0)} title="Similar Publisher/Writer" /> Publisher/Writer
                            </div>
                        </label>

                    </div>

                    <div className="ws-12 box">

                        <div className="box-header well">
                            <span className="ws-6 "> Other Tracks with same
                                {pubWriterType == 1 && <span > Writer </span>}
                                {pubWriterType == 0 && <span > Writer / Publisher </span>}
                                ({AllSplitRow}) record(s) found
                            </span>
                            <button type="button" className="icon-btn primary pull-right" title="Export"><i className="icon-download1"></i>  </button>

                            <div className="ws-4 pull-right">

                                <div className="ws-10">
                                    <input type="text" placeholder="Search Text" value={pubWritersearchFor} onChange={(e: any) => setpubWritersearchFor(e.target.value)} className="ws-12 " />
                                </div>

                                <div className="ws-2">
                                    <button className="btn icon-btn edit" title="Search" onClick={() => AllSplit(activeZone)}>  <i className="icon-search"></i>  </button>
                                </div>
                            </div>

                        </div>

                        {AllSplitRow > 0 && <table className="table">

                            <thead>
                                <tr>
                                    <th><input type="checkbox" title="Select All" />TrackTitle</th>
                                    <th>iSRC</th>
                                    <th>Composer/Writer</th>
                                    <th>Publisher</th>
                                    <th>Collector</th>
                                    <th>Zone</th>
                                    <th>Splits</th>
                                    <th className="center hide">Operation</th>
                                </tr>
                            </thead>

                            <tbody>
                                {allSplit?.map(values => {
                                    return (
                                        <tr>
                                            <td><input type="checkbox" onClick={() => Link_split(values)} checked={checkboxLinked(values)} /> {values.trackName}</td>
                                            <td>{values.trackSeq}</td>

                                            <td>{values.writerName}</td>
                                            <td>{values.publisherName}</td>
                                            <td>{values.collectorName}</td>

                                            <td>{values.groupingID}</td>
                                            <td>{values.publishingSplit}</td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>}

                        {AllSplitRow > 10 && <div className="clearfix pt mb ws-12">

                        </div>}

                    </div>
                </div>

                <div className="box-footer pull-right">
                    <button className=" icon-btn edit width150 height35" title="Save" onClick={() => save_wizard("Save")}> Save</button>
                    {AllSplitRow > 0 && <button className=" icon-btn edit width150 height35" title="Repeat changes to all tracks" onClick={() => save_wizard("All")}> Update All</button>}
                    {AllSplitRow > 0 && <button className=" icon-btn edit width150 height35" title="Repeat changes to selected tracks" onClick={() => save_wizard("Selected")}> Update Selected</button>}
                    <button className=" icon-btn delete width150 height35" onClick={closContactLODSplit}> Close </button>
                </div>

                {
                    (() => {

                        if (deleteStatus) {
                            return <DeleteDialogueBox param={deleteStatus} message={"update split"} onChange={deleteConfirmation} />
                        }
                    })()
                }

            </div>

        </Drawer >
    )
}